export default __webpack_public_path__ + "static/media/nearby.d2fe8d3a.webp";